export const PROPERTY_RECORD = 'PROPERTY_RECORD';
export const REFERENCE_RECORD = 'REFERENCE_RECORD';
export const RECORD_FORMAT_TYPES = {
  [PROPERTY_RECORD]: PROPERTY_RECORD,
  [REFERENCE_RECORD]: REFERENCE_RECORD
};